// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"ba8b9907","880":"2364a886"}[chunkId] + ".chunk.css";
};